const SEARCH_UPDATED_EVENT = 'search:updated';
export enum ESearchType {
  List = 'list',
  Map = 'map',
}
type TSearchUpdatedEventDetail = {
  url: string;
  type: ESearchType;
};
export const dispatchSearchUpdatedEvent = (detail: TSearchUpdatedEventDetail) => {
  dispatchEvent(
    new CustomEvent<TSearchUpdatedEventDetail>(SEARCH_UPDATED_EVENT, {
      detail,
    }),
  );
};
